import { AxiosResponse } from 'axios';
import { BaseService } from './route.service';

export interface NewLeadNotice {
    id: string;
    name: string;
    sourceCampaign?: string | null;
    createdAt: string;
}

export class NotificationsService extends BaseService {
    protected get resourceName(): string {
        return 'crm/notifications';
    }

    public async newLeads(since: string): Promise<AxiosResponse<{ data: NewLeadNotice[] }>> {
        return await this.get('new-leads', { since });
    }
}
